import { styled } from '@linaria/react';

export const ContentArea = styled.div`
  position: relative;
`;
